import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useComponentStyle = makeStyles({
	root: {
		margin: "1rem",
		overflowX: "hidden",
		overflowY: "auto",
		height: "100%",
		boxShadow: tokens.shadow4,
	},
	child: {
		flex: 1,
		width: "100%",
		paddingTop: "0.5rem",
		overflow: "auto",
		backgroundColor: tokens.colorNeutralBackground1,
	},
	transcriptionChild: {
		flex: 1,
		width: "100%",
		paddingTop: "0.5rem",
		overflow: "auto",
		backgroundColor: tokens.colorNeutralBackground1,
		display: "flex",
		flexDirection: "column",
	},
	maxHeight50: {
		maxHeight: "50%",
		marginTop: "1rem",
	},
	regularText: {
		fontSize: tokens.fontSizeHero700,
	},
	linkText: {
		marginTop: "10px",
	},
	themeProvider: {
		width: "100%",
		backgroundColor: "transparent",
		...shorthands.overflow("hidden", "auto"),
	},
	header: {
		...shorthands.padding("8px", "16px"),
		width: "100%"
	},
});
